/* eslint-disable */
import { defaultApiInstance } from '@/compositions/api';

// params.partnerId — партнёр брони: бэк вернёт справочник этого партнёра + «общие» записи.
export function getDrivers(params = {}) {
  return defaultApiInstance.get(`v1/driver`, { params });
}

export function getDriver(id) {
  return defaultApiInstance.get(`v1/driver/${id}`);
}

export function createDriver(data) {
  return defaultApiInstance.post(`v1/driver/create`, JSON.stringify(data));
}

export function updateDriver(id, data) {
  return defaultApiInstance.put(`v1/driver/${id}/update`, JSON.stringify(data));
}

export function deleteDriver(id) {
  return defaultApiInstance.delete(`v1/driver/${id}/delete`);
}
